export const FRIENDS_TO_INVITE_FORM_KEY = 'friendsToInvite'
export const NUMBER_OF_INITIAL_FRIENDS_FETCHED = 20
